import { Model } from 'modules/core/lib/mobx-rest'

interface IHiddenTeam {
  id: string
  ats_company_id: string
  team_id: string
}

class HiddenTeam extends Model<IHiddenTeam> {
  static urlRoot() {
    return '/ats/hidden_teams'
  }
}

export default HiddenTeam
